import { ActivityChangeRequestStatusCode } from '../../api/dto';
import { StatusColor } from './StatusColor';

export const ActivityChangeRequestStatusColorMapping: Record<ActivityChangeRequestStatusCode, StatusColor> = {
    [ActivityChangeRequestStatusCode.REQUESTED]: StatusColor.WARNING,
    [ActivityChangeRequestStatusCode.ACCEPTED]: StatusColor.NORMAL,
    [ActivityChangeRequestStatusCode.REJECTED]: StatusColor.ERROR,
    [ActivityChangeRequestStatusCode.CANCELLED]: StatusColor.ERROR,
    [ActivityChangeRequestStatusCode.INVALIDATED]: StatusColor.ERROR,
};
